export default __webpack_public_path__ + "static/repairBlock2-1df8599d5e839dcde40dc6ed4b955fcf.png";